import moment from 'moment'
import { BulkFormOption } from './interface'
import { DATE_FORMAT } from '@utils/constants'

export const getDaysOptions = () => [
  {
    label: 'Monday(s)',
    value: 1,
  },
  {
    label: 'Tuesday(s)',
    value: 2,
  },
  {
    label: 'Wednesday(s)',
    value: 3,
  },
  {
    label: 'Thursday(s)',
    value: 4,
  },
  {
    label: 'Friday(s)',
    value: 5,
  },
  {
    label: 'Saturday(s)',
    value: 6,
  },
  {
    label: 'Sunday(s)',
    value: 7,
  },
]

export const getTimeOptions = () => {
  let start = moment('00:00', DATE_FORMAT.HM)
  let end = moment('24:00', DATE_FORMAT.HM)
  let result: BulkFormOption[] = []

  while (start.isBefore(end)) {
    result = [
      ...result,
      {
        label: start.format(DATE_FORMAT.HMa),
        value: start.format(DATE_FORMAT.HM),
      },
    ]
    start.add(15, 'minutes')
  }

  return result
}

export const MOCK_INSTRUCTORS = [
  {
    InstructorId: 'a0s3W000008P2eFQAS',
    Name: 'Abongile Tukulula',
    Ranking: 1,
  },
  {
    InstructorId: 'a0s3W000008P0QIQA0',
    Name: 'Adonai Kemrajit',
    Ranking: 2,
  },
  {
    InstructorId: 'a0s3W00000847daQAA',
    Name: 'Adriana Cifuentes',
    Ranking: 3,
  },
  {
    InstructorId: 'a0s3W000008P0Q3QAK',
    Name: 'Alicia Naraidu',
    Ranking: 4,
  },
  {
    InstructorId: 'a0s3W000000ebpOQAQ',
    Name: 'Analize Viljoen',
    Ranking: 5,
  },
  {
    InstructorId: 'a0s3W000004utG0QAI',
    Name: 'Andrea Jagger-Wells',
    Ranking: 6,
  },
  {
    InstructorId: 'a0s3W000004uFI3QAM',
    Name: 'Andrew Coetzee',
    Ranking: 7,
  },
  {
    InstructorId: 'a0s3W0000083mpAQAQ',
    Name: 'Andrew Filip',
    Ranking: 7,
  },
  {
    InstructorId: 'a0s3W000004td7bQAA',
    Name: 'Andrew Sowter',
    Ranking: 8,
  },
  {
    InstructorId: 'a0s3W000000elCvQAI',
    Name: 'Aneeqa Vignola',
    Ranking: 9,
  },
  {
    InstructorId: 'a0s3W000004w8BZQAY',
    Name: 'Anelisa Kelemi',
    Ranking: 10,
  },
  {
    InstructorId: 'a0s3W000000ehmVQAQ',
    Name: 'Angela Carvajal',
    Ranking: 10,
  },
  {
    InstructorId: 'a0s3W000000f6EbQAI',
    Name: 'Anke van Rensburg',
    Ranking: 11,
  },
]
